import {getBulkActionSlice} from 'src/components/bulk-tool';

import type {
    BulkActionIdSelector,
    BulkActionShownSelector,
    BulkActionTaskSelector,
} from 'src/components/bulk-tool';

export const dischargeAccountsEntitlementsSlice = getBulkActionSlice(
    'dischargeAccountsEntitlementsResult',
);

export const selectDischargeAccountsEntitlementsShown: BulkActionShownSelector = state =>
    state.bulkUpdateResult.dischargeAccountsEntitlementsResult.shown;

export const selectDischargeAccountsEntitlementsBulkUuid: BulkActionIdSelector = state =>
    state.bulkUpdateResult.dischargeAccountsEntitlementsResult.uuid;

export const selectDischargeAccountsEntitlementsTask: BulkActionTaskSelector = state =>
    state.bulkUpdateResult.dischargeAccountsEntitlementsResult.backgroundTask;

export const {
    setUuid,
    setBackgroundTask,
    setShown,
    clearResult,
} = dischargeAccountsEntitlementsSlice.actions;
